import React, { FC, memo, useRef } from 'react'
import s from './PromoRollCard.module.sass'
import { ErrorBoundary } from '@shared/lib/components/ErrorBoundary'
import { EGG } from '@shared/api/analytics'
import { useIntersectionAnalytic } from '@shared/lib/hooks/useIntersectionAnalytic'
import { PickAnalytic } from '@shared/api/analytics/types/types'
import { PromoRollCardKuper } from '@features/PromoRoll/ui/PromoRollCardKuper'
import { PromoRollCardDefault } from '@features/PromoRoll/ui/PromoRollCardDefault'
import { TypePromoItemVariants } from '@features/PromoRoll/types/types'

interface Props {
  data: TypePromoItemVariants
  analytic: PickAnalytic<'section_index'>
  className?: string
}

const componentsByType = {
  kuper: PromoRollCardKuper,
}

const PromoRollCard: FC<Props> = ({ data, analytic, className = '' }) => {
  const element = useRef()

  const handleLink = () => {
    EGG.entity.promo_card.promo_card_click(analytic)
  }

  useIntersectionAnalytic(element, () => EGG.entity.promo_card.promo_card_view(analytic))

  const Component = componentsByType[data.id] || PromoRollCardDefault

  return (
    <ErrorBoundary>
      <div className={s.card} ref={element}>
        <Component data={data} className={className} onClick={handleLink} />
      </div>
    </ErrorBoundary>
  )
}

export default memo(PromoRollCard)
